module.exports = __webpack_public_path__ + "img/team-5.6a179e53.png";